<template>
  <div class="container componentsDC">
    <el-form :model="queryCondition" ref="queryCondition" label-width="140px">
      <el-row>

        <el-col :span="7">
          <el-form-item :label="$t('base.carriers.carriersCode')" prop="carrierCode">
            <!--承运商编码-->
            <el-input v-model.trim="queryCondition.carrierCode" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :label="$t('base.carriers.carriersName')" prop="carrierNmae">
            <!--承运商名称-->
            <el-input v-model="queryCondition.carrierNmae" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('common.createDate')" class="createDateArr" prop="dateRange">
            <!--创建日期-->
            <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
            <!-- <el-date-picker v-model="queryCondition.createDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')"></el-date-picker> -->
            <!-- 至 -->
            <!-- <el-date-picker v-model="queryCondition.updateDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')"></el-date-picker> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <el-form-item :label="$t('base.dc.dcName')" prop="supplierName">
            <!--DC名称-->
            <el-input v-model="queryCondition.supplierName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :label="$t('base.dc.dcNo')" prop="supplierCode">
            <!--DC编码-->
            <el-input v-model.trim="queryCondition.supplierCode" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :label="$t('settlementUnit.ApprovalStatus')" prop="auditStatus">
            <!--状态-->
            <ic-select clearable table="TM_SUPPLIER" field="STATUS" v-model="queryCondition.auditStatus" disabled></ic-select>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="4">
          <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="action-btn-row">
      <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      <!-- <el-button type="primary" @click="toggleSelection">{{$t('common.Deselected')}}</el-button> -->
    </el-row>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420' row-key="tmSupplierId" @selection-change="selectionChange">
      <el-table-column align="center" v-if="multipleSelectionFlag" prop="tmSupplierId" type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column align="center" v-else width="55">
        <template slot-scope="scope">
          <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmSupplierId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('base.dc.dcName')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('base.dc.dcNo')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="carrierCode" :label="$t('base.carriers.carriersCode')"></el-table-column><!-- 承运商编码 -->
      <el-table-column show-overflow-tooltip prop="carrierNmae" :label="$t('base.carriers.carriersName')"></el-table-column><!-- 承运商名称 -->
      <el-table-column show-overflow-tooltip prop="dctypeI18n" label="DC Type"></el-table-column>
      <el-table-column show-overflow-tooltip prop="statusI18n" :label="$t('base.dc.dcStatus')"></el-table-column><!-- DC状态 -->
      <el-table-column show-overflow-tooltip prop="description" :label="$t('common.approvalRemarks')"></el-table-column><!-- 审批备注 -->
      <el-table-column show-overflow-tooltip prop="auditStatusI18n" :label="$t('settlementUnit.ApprovalStatus')">
        <!-- <template slot-scope="scope">{{scope.row.auditStatus|ic("TM_SUPPLIER","STATUS")}}</template> -->
      </el-table-column><!-- 审批状态 -->
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import DCApi from "@/api/DC/DC";
import { Message } from "element-ui";
export default {
  components: { IcSelect },
  name: 'dc-sel-page',
  props: {
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    disabledStatusFlag: {
      type: Boolean,
      default: true
    },
    type: {
      type: Array,
      default: new Array("DC")//接受参数xxx;xxxx
    },
    showFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      totalCount: 0,
      tableList: [],
      labelPosition: 'right',
      queryCondition: {
        supplierCode: '',
        supplierName: '',
        carrierCode: '',
        carrierNmae: '',
        auditStatus: 'approve',//只获取完成的
        pageNum: 1,
        pageSize: 15,
        createDate: '',
        updateDate: '',
        supperSupplierIdNull: "Y",
        status: "1",
      },
      dateRange: [],
      statusList: [],
      multipleSelection: [],
      selectRows: [],
      radioVal: null
    }
  },
  created() {
    this.queryData(1);
  },
  mounted() {
  },
  methods: {
    selectionChange(rows) {
      let that = this
      this.selectRows = [];
      if (rows) {
        rows.forEach(val => {
          that.selectRows.push(val);
        });
      }
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      if (this.dateRange.length > 0) {
        this.queryCondition.createDate = this.dateRange[0]
        this.queryCondition.updateDate = this.dateRange[1]
      }
      DCApi.getDCList(this.queryCondition).then(res => {
        this.tableList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    restQueryForm() {
      this.$refs['queryCondition'].resetFields();
      this.dateRange = []
      this.queryCondition.createDate = ''
      this.queryCondition.updateDate = ''
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryData();
    },
    clickSelectMethod: function () {
      this.$emit('subCallMethod', this.selectRows);
      // if(this.selectRows.length==0){
      //     Message({message: "请选择到货仓库(DC)", type: "warning"});
      // }else{
      //     this.$emit('subCallMethod', this.selectRows);
      // }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    toggleSelection() {
      this.$refs.tableList.clearSelection();
    },
  },
  extends: commonFunction
}
</script>
<style lang="scss">
.componentsDC {
  .createDateArr .el-form-item__content {
    display: flex;
  }
}
</style>
